/*
  Плитка счётчика: подпись, сумма, объяснение под значком «i» — §3.11.3.

  Вынесена в общую часть 09.09.2026, когда те же три счётчика понадобились на
  первом экране (§3.1.3). Второй копией разметки «посчитать нечем» выглядело бы
  на двух экранах по-разному, а разница между нулём и отсутствием измерения -
  единственное, ради чего плитка устроена сложнее строки текста.

  **Цвет означает то же, что во всём кабинете** (§4.5.3). Красный - потеря денег
  во времени; расход на платформу красным не красится, это цена, а не потеря.
  Зелёный - деньги, которые вернулись или не выпали. Величина, которую посчитать
  нечем, цвета не получает вовсе: у неё нет знака.
*/

import { accounts as accountsWord, money } from '../api/format.js'
import InfoHint from './InfoHint.jsx'

export default function CounterTile({ counter, tone = 'plain' }) {
  // Знак есть только у измеренной величины: «посчитать нечем» - не ноль и не
  // потеря, и красить её нельзя ни в какой цвет.
  const known = counter.amount !== null
  const painted = known ? tone : 'plain'

  return (
    <div className={`tile tile--${painted}`}>
      <div className="tile__head">
        <div className="money__label">{counter.title}</div>
        <InfoHint text={counter.explanation} title="Откуда цифра" />
      </div>
      {/*
        «Посчитать нечем» набрано мельче суммы: крупным шрифтом отсутствие
        измерения кричит громче измеренных денег, а это ровно наоборот тому,
        зачем экран нужен.
      */}
      <div className={`money__value${known ? '' : ' money__value--unknown'}`}>
        {known ? money(counter.amount) : 'посчитать нечем'}
      </div>
      {counter.accounts ? <div className="money__note">{accountsWord(counter.accounts)}</div> : null}
    </div>
  )
}
